import * as React from 'react';

import styled from 'styled-components';

import { COLOR, FONT_SIZE, FONT_STACK, SPACING } from '../../packages/constants';
import { MultiSelectInput } from '../multi-select-input';

export type MultiSelectVariants = 'legacy' | 'normal' | 'modern';

interface DataItem {
    name: string;
    id: string;
    selected: boolean;
}

interface Category {
    categoryName: string;
    options: DataItem[];
}

export interface MultiSelectProps {
    dataSet: Category[];
    dataId: string;
    handleApplyButton: (e?: Category[]) => void;
    handleCancelButton: (e?: DataItem[]) => void;
    label: string;
    disabled?: boolean;
    thinLabel?: boolean;
    maxHeight?: string;
    maxWidth?: string;
    hasFilter?: boolean;
    variant?: MultiSelectVariants;
}

const StyledMultiSelect = styled.div``;

interface StyledLabelProps {
    disabled?: boolean;
    invalid?: boolean;
    thinLabel?: boolean;
    hasLegacyStyles?: boolean;
}

const StyledLabel = styled.label<StyledLabelProps>`
    padding-bottom: ${(props) => (props.hasLegacyStyles ? 0 : SPACING.XX_SMALL)};
    font-family: ${FONT_STACK};
    font-size: ${(props) => (props.hasLegacyStyles ? FONT_SIZE.X_SMALL : FONT_SIZE.SMALL)};
    font-weight: ${(props) => (props.thinLabel ? '400' : '700')};
    line-height: ${(props) => (props.hasLegacyStyles ? 'normal' : FONT_SIZE.MEDIUM)};
    margin-bottom: ${(props) => (props.hasLegacyStyles ? '8px' : 0)};
    display: block;
    color: ${(props) =>
        props.invalid ? COLOR.PRIMARY.RED : props.hasLegacyStyles ? COLOR.PRIMARY.BLACK : COLOR.MAIN.LABEL_TEXT};
    opacity: ${(props) => (props.disabled ? '0.7' : '1')};
`;

export const MultiSelect = React.forwardRef<HTMLDivElement, MultiSelectProps>(
    (
        {
            dataSet,
            dataId,
            label,
            disabled,
            handleApplyButton,
            handleCancelButton,
            hasFilter = true,
            maxHeight = '240px',
            maxWidth,
            thinLabel,
            variant = 'normal',
            ...props
        },
        ref,
    ) => {
        const hasLegacyStyles = variant === 'legacy';

        return (
            <StyledMultiSelect ref={ref} {...props}>
                <StyledLabel disabled={disabled} thinLabel={thinLabel} hasLegacyStyles={hasLegacyStyles}>
                    {label}
                </StyledLabel>
                <MultiSelectInput
                    dataSet={dataSet}
                    dataId={dataId}
                    handleApplyButton={handleApplyButton}
                    handleCancelButton={handleCancelButton}
                    disabled={disabled}
                    maxHeight={maxHeight}
                    maxWidth={maxWidth}
                    hasFilter={hasFilter}
                    variant={variant}
                />
            </StyledMultiSelect>
        );
    },
);
MultiSelect.displayName = 'MultiSelect';
